import { z } from 'zod';
import { isDefined } from '../typeUtils/index.js';
/**
 * An enum field that may be omitted from the input but always parses to a value.
 * The inferred key stays optional so callers can leave it out when constructing an instance.
 */
export function OptionalEnumSchema(nativeEnum, defaultValue) {
    // Parsing always yields a defined value; the cast presents the schema as a ZodOptional
    // so the inferred key stays optional (callers may omit it).
    return z.enum(nativeEnum).optional().default(defaultValue);
}
/** A field accepting either a single `schema` value or an array of them. */
export function OneOrManySchema(schema, options) {
    const { arrayMax } = options ?? {};
    let arraySchema = z.array(schema);
    if (isDefined(arrayMax)) {
        arraySchema = arraySchema.max(arrayMax);
    }
    return z.union([schema, arraySchema]);
}
//# sourceMappingURL=utils.js.map